import React, { useEffect, useState, ReactElement } from "react";

import { useTranslation } from "react-i18next";

import { useSelector, shallowEqual } from "react-redux";

// Components
import EmailPassWordForm from "./signInMethod/emailPassword";
import AnonymousForm from "./signInMethod/anonymous";
import ParticipantId from "./signInMethod/participantId";

const Login = (): ReactElement => {
  const { t } = useTranslation();

  const [message, setMessage] = useState("");
  const { generalSettings } = useSelector(
    ({ generalSettings }) => ({ generalSettings }),
    shallowEqual
  );

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.message) {
      setMessage(params.message);
    }
  }, []);

  return (
    <div className="d-flex flex-column mb-4">
      <div className="mb-3">
        <div className="d-flex align-items-start justify-content-between">
          <h1 className="mb-2">{t("LOGIN_TITLE")}</h1>
        </div>

        <p className="m-0">{t("LOGIN_DESCRIPTION")}</p>
        {!!message && (
          <div className="alert alert-primary" role="alert">
            {message}
          </div>
        )}
      </div>
      {!!generalSettings &&
        generalSettings.signInMethod === "emailPassword" && (
          <EmailPassWordForm
            registrationEnabled={generalSettings?.registrationEnabled}
          />
        )}
      {!!generalSettings && generalSettings.signInMethod === "anonymous" && (
        <AnonymousForm />
      )}
      {!!generalSettings &&
        generalSettings.signInMethod === "participantId" && (
          <ParticipantId
            registrationEnabled={generalSettings?.registrationEnabled}
          />
        )}
    </div>
  );
};

export default Login;
